module.exports = __webpack_public_path__ + "493645e6a01901e910d617d3e7d680cc.png";